
<div class="search-bar-header {{class}}" [ngClass]="{ expanded: (expanded$ | push) !== false }" > 

	<header class="search-bar-header-top max-width-header">

		<div class="button-hidden-wrapper left">
			<span class="sort-button button-hidden" (click)="controlPanel(0)" matRipple [class.active]="(expanded$ | push) === 0" >
				<app-icon-close class="filter-icon" icon="tune" [buttonActive]="(expanded$ | push) === 0" ></app-icon-close>
				<p class="label">{{(pageParams$ | push).sortBy.label}}</p>
			</span>
		</div>
		
		<span class="search-middle">
				<p 
					class="search-result"
					
					title="'nalezeno ' + {{ (count$ | push) }} + ' položek'"
				>
					{{ (count$ | push) }}
				</p>
		</span>

		<div class="button-hidden-wrapper right">
			<span class="filter-button button-hidden" (click)="controlPanel(1)" matRipple [class.active]="(expanded$ | push) === 1" >
				<p class="label">Filtry</p>
				<app-icon-close class="filter-icon" icon="search" [buttonActive]="(expanded$ | push) === 1" ></app-icon-close>
			</span>
		</div>

		
	</header>

	<div class="active-filters max-width-header" *ngIf="(pageParams$ | push).activeFilters.length > 0" [@ifHeightAnimation]>
		<ul>
			<li *ngFor="let item of (pageParams$ | push).activeFilters; trackBy: trackByMethod" [@fadeIfAnimation]>
				<app-facet class="button facet-top-bar" [chip]="item" [displayCount]="false" ></app-facet>
				<!-- <span>#{{item.entityLabel}}</span> -->
			</li>
		</ul>
	</div>


</div>

<nav class="facets-wrapper " 
	
	*ngIf="(expanded$ | push) !== false"
	[@facetsAnimation]
>

	<mat-tab-group 
		class="max-width-header"
		[selectedIndex]="(selectedIndex$ | push)"
		[animationDuration]="(animationDuration$ | push)"
		[disablePagination]="true"
		[dynamicHeight]="true"
	>
	  <mat-tab>
	     <app-sort [sortBy]="(pageParams$ | push).sortBy" [queryParams]="(pageParams$ | push).queryParams" ></app-sort>
	  </mat-tab>
	  <mat-tab>
	     <app-facets [pageParams$]="pageParams$" [pageName]="pageName" ></app-facets>
	  </mat-tab>
	</mat-tab-group>

</nav>



